import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../api/client";

export default function ReinitialiserMotDePasse() {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [nouveau, setNouveau] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const e = searchParams.get("email");
    if (e) setEmail(e);
  }, [searchParams]);

  const submit = async () => {
    setError("");
    if (!email.trim()) { setError("Indiquez votre email."); return; }
    if (!/^\d{8}$/.test(code.trim())) {
      setError("Le code doit comporter 8 chiffres."); return;
    }
    if (nouveau.length < 10) {
      setError("Le mot de passe doit faire au moins 10 caractères."); return;
    }
    if (nouveau !== confirm) {
      setError("Les mots de passe ne correspondent pas."); return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", {
        email: email.trim(),
        code: code.trim(),
        nouveau_mot_de_passe: nouveau,
      });
      setDone(true);
    } catch (e) {
      setError(e.message || "Code invalide ou expiré.");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="container" style={{ maxWidth: 460 }}>
        <h1>Mot de passe modifié</h1>
        <div className="card">
          <div className="success">
            Votre mot de passe a bien été changé. Vous pouvez maintenant vous
            connecter.
          </div>
          <button className="mt-2" onClick={() => nav("/connexion")}>
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 460 }}>
      <h1>Réinitialiser le mot de passe</h1>
      <p className="muted mb-3">
        Saisissez le code à 8 chiffres reçu par email, puis choisissez un
        nouveau mot de passe.
      </p>
      <div className="card">
        {error && <div className="error">{error}</div>}
        <div className="field"><label>Email</label>
          <input type="email" value={email}
                 onChange={(e) => setEmail(e.target.value)} /></div>
        <div className="field"><label>Code reçu (8 chiffres)</label>
          <input value={code} onChange={(e) => setCode(e.target.value)}
                 inputMode="numeric" maxLength={8}
                 style={{ letterSpacing: "0.3em", fontFamily: "monospace" }} /></div>
        <div className="field"><label>Nouveau mot de passe (10 caractères min.)</label>
          <input type="password" value={nouveau}
                 onChange={(e) => setNouveau(e.target.value)} /></div>
        <div className="field"><label>Confirmer le mot de passe</label>
          <input type="password" value={confirm}
                 onChange={(e) => setConfirm(e.target.value)}
                 onKeyDown={(e) => e.key === "Enter" && submit()} /></div>
        <button onClick={submit} disabled={busy}>
          {busy ? "Validation…" : "Réinitialiser mon mot de passe"}
        </button>
        <p className="muted mt-2">
          Vous n'avez pas reçu de code ?{" "}
          <Link to="/mot-de-passe-oublie">Demander un nouveau code</Link>
        </p>
      </div>
    </div>
  );
}
